import API from 'services/api';

export const deleteOffice = ({ officeId }: { officeId: string }) => {
  return API.delete(`/api/offices/${officeId}`);
};
